import * as React from 'react';
import { SimpleModal } from 'Src/components/SimpleModal/SimpleModal';

type Props = {
  isOpen: boolean;
  status?: 'success' | 'info' | 'warning';
  title: string;
  message?: string;
  lines?: string[];
  onClose: () => void;
};

export const ClubProgrammeStatusModal: React.FC<Props> = ({
  isOpen,
  status = 'success',
  title,
  message,
  lines = [],
  onClose
}) => {
  if (!isOpen) return null;

  const safeLines = Array.isArray(lines) ? lines.filter(Boolean) : [];
  const statusLabel =
    status === 'warning' ? 'Please review the result' : status === 'info' ? 'Update complete' : 'Activation complete';

  return (
    <SimpleModal
      isOpen={isOpen}
      title={title}
      onCloseClick={onClose}
      showFooter={false}
      isBodyBold={false}
      customClass={`cpProgrammeDialog cpProgrammeStatusDialog is${status.charAt(0).toUpperCase()}${status.slice(1)}`}
      bodyClassName="cpProgrammeDialogBody"
      dialogStyle={{ maxWidth: 500 }}
    >
      <div className="cpProgrammeDialogContent">
        <div className={`cpProgrammeDialogLead is${status.charAt(0).toUpperCase()}${status.slice(1)}`}>
          <span className="cpProgrammeDialogIcon" aria-hidden="true">
            {status === 'success' ? (
              <svg viewBox="0 0 24 24">
                <circle cx="12" cy="12" r="8.5" />
                <path d="m8.25 12.1 2.45 2.45 5.25-5.25" />
              </svg>
            ) : status === 'warning' ? (
              <svg viewBox="0 0 24 24">
                <path d="M12 8.25v4.5" />
                <path d="M12 16.5h.01" />
                <path d="M10.18 4.62 3.3 16.56A2 2 0 0 0 5.03 19.5h13.94a2 2 0 0 0 1.73-2.94L13.82 4.62a2.1 2.1 0 0 0-3.64 0Z" />
              </svg>
            ) : (
              <svg viewBox="0 0 24 24">
                <circle cx="12" cy="12" r="8.5" />
                <path d="M12 10.75v5" />
                <path d="M12 7.75h.01" />
              </svg>
            )}
          </span>
          <div>
            <strong>{statusLabel}</strong>
            {message ? <p>{message}</p> : null}
          </div>
        </div>

        {safeLines.length > 0 ? (
          <div className="cpProgrammeStatusList">
            {safeLines.map((line, index) => (
              <div key={`${line}-${index}`}>
                <span aria-hidden="true">✓</span>
                <p>{line}</p>
              </div>
            ))}
          </div>
        ) : null}

        <div className="cpProgrammeDialogActions">
          <button type="button" className="cpProgrammeDialogButton isPrimary" onClick={onClose}>
            Done
          </button>
        </div>
      </div>
    </SimpleModal>
  );
};

ClubProgrammeStatusModal.displayName = 'ClubProgrammeStatusModal';
